import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { ADMIN_COLORS as C } from '@/components/admin/AdminPage';
import { xLength } from '@/utils/announcementTemplates';

const CopyButton = ({ text, testId }) => {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (_) {
      const ta = document.createElement('textarea');
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      ta.remove();
    }
    setDone(true);
    setTimeout(() => setDone(false), 1800);
  };
  return (
    <button type="button" onClick={copy} className="flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-bold"
      style={{ background: done ? '#10B981' : C.accent, color: done ? '#FFFFFF' : C.accentInk, transition: 'background-color 150ms' }}
      data-testid={testId}>
      {done ? <Check size={14} /> : <Copy size={14} />}
      {done ? 'تم النسخ' : 'نسخ'}
    </button>
  );
};

export const PostField = ({ label, text, dir, testId, xLimit }) => {
  const count = xLimit ? xLength(text) : text.length;
  const over = xLimit && count > xLimit;
  return (
    <div className="mb-3">
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-xs font-semibold" style={{ color: C.muted }}>{label}</span>
        <div className="flex items-center gap-2">
          <span className="text-xs" style={{ color: over ? '#FCA5A5' : C.muted }} data-testid={`${testId}-count`}>
            {xLimit ? `${count} / ${xLimit}` : `${count} حرفاً`}
          </span>
          <CopyButton text={text} testId={`${testId}-copy`} />
        </div>
      </div>
      <textarea readOnly value={text} dir={dir} rows={Math.min(14, text.split('\n').length + 2)}
        className="w-full rounded-lg p-3 text-sm leading-relaxed resize-y outline-none"
        style={{ background: C.field, border: `1px solid ${over ? '#F87171' : C.border}`, color: C.primary }}
        data-testid={testId} />
    </div>
  );
};

export const PlatformCard = ({ icon: Icon, name, hint, children, testId }) => (
  <section className="rounded-2xl p-4" style={{ background: C.card, border: `1px solid ${C.border}` }} data-testid={testId}>
    <div className="flex items-center gap-2 mb-1">
      <Icon size={18} color={C.accent} />
      <h3 className="font-bold">{name}</h3>
    </div>
    {hint && <p className="text-xs mb-3" style={{ color: C.muted }}>{hint}</p>}
    {children}
  </section>
);
